import {
    Component,
    computed,
    effect,
    HostListener,
    Input,
    OnInit,
    signal,
    ViewChild,
    WritableSignal
} from '@angular/core';
import {EstadoTramiteEnum, TramiteItem, TramiteTipoRequisitoItem} from '../interfaces/tramites.interface';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {TramiteService} from '../../services/tramite.service';
import {catchError, debounceTime, distinctUntilChanged, map, of, Subject, throwError} from 'rxjs';
import {Message, MessageService} from 'primeng/api';
import {
    AreaChanged,
    AreasInterfaces,
    EtapasProyectoInterfaces,
    LoteInterface,
    TipoAreaEnum,
    UnidadesHabitacionalesInterface
} from "../interfaces/formulario.interfaces";
import {SdetTramiteService} from "../../services/sdet-tramite.service";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {CatalogoInterface, ProyectoItem} from "../../../interfaces/proyecto.interface";
import {ProyectoService} from "../../../proyectos/services/proyecto.service";
import {TarifarioInterface} from "../../../interfaces/pagos.interface";
import {FileUpload} from "primeng/fileupload";
import {isAlphaNumericValidEvent} from "../../../../shared/services/utils-service";
import Swal from "sweetalert2";
import {Location} from "@angular/common";
import {CatalogoService} from "../../../../shared/services/catalogo-service";
import {switchMap, tap} from "rxjs/operators";
import {Table} from "primeng/table";
import {FormularioAService} from "../../services/formulario-a.service";


@Component({
    selector: 'app-formulario-a',
    templateUrl: './formulario-a.component.html',
    providers: [MessageService],
    styleUrls: ['./formulario-a.component.scss']
})
export class FormularioAComponent implements OnInit {
    cantidadUnidades: number | null = null;
    nivelSeleccionado: CatalogoInterface | null = null
    unidadesHabitacionales: UnidadesHabitacionalesInterface[] = []
    tramiteCompleto: boolean = true
    listaEntorno: CatalogoInterface[] = []
    tarifa: number = 0
    /**
     * Servicio recibido como parametro
     */
    selected: TramiteItem = null!
    cantidadLotes: WritableSignal<number> = signal(0)
    // cantidadLotes: number = 0
    listaLocalizacion: CatalogoInterface[] = []
    listaUrbanizacion: CatalogoInterface[] = []
    listaDensidad: CatalogoInterface[] = []
    listaNivel: CatalogoInterface[] = []
    tipoLotes: CatalogoInterface[] = []
    urbanizacionSeleccionada: CatalogoInterface | null = null
    cantidadEtapa: number = 0
    numeroMes: number = 0
    listaEtapas: EtapasProyectoInterfaces[] = []
    errorEtapas: boolean = false
    errorUnidades: boolean = false
    inputAreaTotal = new Subject<string>();
    requisitoTipoTramite: TramiteTipoRequisitoItem[] = [];
    idProyecto: string | null = null
    idTramite: string | null = null
    entornoProyecto: string = ''
    esValidaAreas: boolean = true;
    densidadSeleccionada: WritableSignal<CatalogoInterface | null> = signal(null)
    localizacionSeleccionada: WritableSignal<CatalogoInterface | null> = signal(null)
    esConstruccion: WritableSignal<boolean> = signal(false)
    isLoading = signal(false);
    formularioActual: 'forma' | 'construccion' = 'forma';
    messages: Message[] = [];
    @Input() _showLoader: boolean = false
    @ViewChild('cargaArchivos') cargaArchivos: FileUpload | any;
    @ViewChild('dtEtapasProyecto') dtEtapasProyecto!: Table;
    @ViewChild('dtUnidadesHabitacionales') dtUnidadesHabitacionales!: Table;
    @Input("prj") prj!: ProyectoItem;
    prjId$ = this.route.params.pipe(map((params) => params['idProyecto']));

    constructor(private messageService: MessageService, public router: Router, private route: ActivatedRoute,
                private proyectoService: ProyectoService, private catalogoService: CatalogoService,
                protected tramiteService: TramiteService, private loginServices: LoginServices,
                private sdetTramiteService: SdetTramiteService, private location: Location, private formularioAService:FormularioAService) {
    }

    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.preFetchProyectoId()
        if (this.tramiteService.idProyecto()) {
            this.proyectoService.getGeneralesProyecto(this.tramiteService.idProyecto()!)
                .pipe(
                    catchError(error => {
                        return throwError(error)
                    })
                )
                .subscribe(
                    resp => {
                        if (resp.status == 200) {
                            this.tramiteService.proyectoAsignado.set(resp.body!)
                            this.entornoProyecto = this.tramiteService.proyectoAsignado()[0].entorno.toString()
                            this.getInfoAreaProyecto(this.tramiteService.idProyecto()!, this.tramiteService.proyectoAsignado()[0].idTipoProyecto!, "tipoareas");
                            if (this.tramiteService.proyectoAsignado()[0].idTipoProyecto != 4) {
                                this.esConstruccion.set(false)
                                this.catalogoService.getCatalogo('tipo_lote')
                                    .subscribe(
                                        resp => {
                                            this.tipoLotes = resp
                                        }
                                    );
                            } else {
                                this.esConstruccion.set(true)
                            }
                        }
                    }
                )
        }
        this.route.paramMap.subscribe((params: ParamMap) => {
            if (params.get('idTramite') != null) {
                this.idTramite = +params.get('idTramite')! ? params.get('idTramite') : null
                if (this.idTramite != null) {
                    this.sdetTramiteService.obtenerSdetItem(this.tramiteService.idProyecto()!, this.idTramite)
                        .subscribe(
                            resp => {
                                this.selected = resp.body!
                            }
                        )
                }
                if (params.get('idProyecto') != null) {
                    this.idProyecto = +params.get('idProyecto')! ? params.get('idProyecto') : null
                    if (this.idProyecto != null) {
                        this.tramiteService.getRequisitosPorParametros(this.idTramite!, this.idProyecto, this.requisitoTipoTramite);
                    }
                }
            }
            this.catalogoService.getCatalogo('entorno')
                .subscribe(
                    resp => {
                        this.listaEntorno = resp
                    }
                )
        });
        this.tramiteService.existeAreasConProyecto(parseInt(this.idProyecto!)).subscribe(
            resp => {
                this.tramiteService.areasGeneralidadesTerrenoCompletadas.set(resp.body);
            }
        );
    }

    private preFetchProyectoId() {
        console.log(`preFetchProyectoId`)
        this.prjId$.subscribe((id) => {
            if (id) {//load everything prj sequence.
                this.tramiteService.idProyecto.set(id)
            }
        });
        console.log(`params -> this.tramite.idProyecto  -> ${this.tramiteService.idProyecto()}`)
    }

    //Validacion para activar los inputs de las areas, si tienen o no requieren pago o no tienen un tramite asignado o vienen vacios
    isReadOnly = computed(() => {
        return this.selected.idEstadoTramite === EstadoTramiteEnum.FormularioCompleto || this.selected.idEstadoTramite === EstadoTramiteEnum.PagoRealizado;
    });

    formCompletado = computed(() => {
        if(this.selected.idEstadoTramite !== null || this.selected.idEstadoTramite !== undefined){
            return this.selected.idEstadoTramite === EstadoTramiteEnum.FormularioCompleto;
        }else{
            return this.selected.idEstadoTramite === EstadoTramiteEnum.FormularioCompleto;
        }
    })

    //Metodo para activar el formulario condicional
    esFormularioActivo(tipo: string): boolean {
        return this.formularioActual === tipo;
    }
    /**
     Metodo que muestra la informacion de areas y de la area total del proyecto previamente registrado en el FU.
     */
    getInfoAreaProyecto(idProyecto: string, tipoProyecto: number, info: string | null) {
        if (info == "tipoareas" && tipoProyecto != null || undefined) {
            this.tramiteService.getObtenerTipoAreas(idProyecto!, []).subscribe(
                resp => {
                    this.tramiteService.tiposAreas.set(resp)
                    this.tramiteService.areaTotalSignal.set(this.getAreaByTipo(TipoAreaEnum.Areaproyecto!));
                }
            );
        }
    }

    //Area total siempre debe ser mayor que la suma de las areas a desarrollar e impermeabilizar.
    isAreasGeneralesValidar() {
        let areaTotal = this.getAreaByTipo(TipoAreaEnum.Areaproyecto!) || 0;
        let areaDesarrollar = this.getAreaByTipo(TipoAreaEnum.Adesarrollar!);
        let areaImpermeabilizar = this.getAreaByTipo(TipoAreaEnum.Aimpermeabilizar!);
        if(areaDesarrollar>=0 || areaImpermeabilizar>=0){
            let suma = areaDesarrollar + areaImpermeabilizar;
            this.esValidaAreas = areaTotal >= suma;
        }else{
            this.esValidaAreas=false
        }
    }

    //Area total siempre debe ser mayor que la suma de las areas a desarrollar e impermeabilizar.
    isAreaTerrenoValida() {
        let sumaTotal = 0
        const areaTotal=this.getAreaByTipo(TipoAreaEnum.Areaproyecto!);
        let areaDesarrollar=this.getAreaByTipo(TipoAreaEnum.Adesarrollar!);
        let areaImpermeabilizar=this.getAreaByTipo(TipoAreaEnum.Aimpermeabilizar!);
        sumaTotal = (areaDesarrollar) + (areaImpermeabilizar);
        return (areaTotal)>=sumaTotal;

    }

    //Area total siempre debe ser mayor que la suma de las areas estimadas.
    isAreasEstimadasValida(tipoArea: boolean) {
        let sumaTotal = 0;
        const areaProyecto = this.getAreaByTipo(TipoAreaEnum.Areaproyecto!);
        if (!tipoArea) {
            sumaTotal = this.tramiteService.tiposAreas()
                .filter(area => area.idTipoArea === TipoAreaEnum.Arealotes || area.idTipoArea === TipoAreaEnum.Areaverde || area.idTipoArea === TipoAreaEnum.Areaequipamientosocial || area.idTipoArea === TipoAreaEnum.Areaproteccion || area.idTipoArea === TipoAreaEnum.Areacirculacion || area.idTipoArea === TipoAreaEnum.Arealotetipo)
                .reduce((sum, area) => sum + (area?.area!), 0);
       } else if (tipoArea) {
            sumaTotal = this.tramiteService.tiposAreas()
                .filter(area => area.idTipoArea === TipoAreaEnum.Areaconstruccion || area.idTipoArea === TipoAreaEnum.Areaampliar || area.idTipoArea === TipoAreaEnum.Areatechar || area.idTipoArea === TipoAreaEnum.Arearemodelar || area.idTipoArea === TipoAreaEnum.Areademoler || area.idTipoArea === TipoAreaEnum.Areapatiosyjardines)
                .reduce((sum, area) => sum + (area?.area!), 0);

        }
        return areaProyecto >= sumaTotal;
    }

    calcularPorcentajeTotal(area: number): string {
        const areaProyecto = this.getAreaByTipo(TipoAreaEnum.Areaproyecto!);
        let area_calcular = area || 0;
        const area_total = areaProyecto || 0;

        if (area_total > 0 && area_calcular > 0) {
            let porcentaje = ((area_calcular * 100) / area_total).toFixed(2);
            return `- ${porcentaje}%`;
        }
        return '';
    }

    isValidarAreas(tipoArea: boolean) {
        let validez = false;
        const areaProyecto = this.getAreaByTipo(TipoAreaEnum.Areaproyecto!);
        let sumAreas = 0;
        // Validación para tipo de áreas diferente de construcción
        if (!tipoArea) {
            sumAreas = this.tramiteService.tiposAreas()
                .filter(area => area.idTipoArea === TipoAreaEnum.Arealotes || area.idTipoArea === TipoAreaEnum.Areaverde || area.idTipoArea === TipoAreaEnum.Areaequipamientosocial || area.idTipoArea === TipoAreaEnum.Areaproteccion || area.idTipoArea === TipoAreaEnum.Areacirculacion || area.idTipoArea === TipoAreaEnum.Arealotetipo)
                .reduce((sum, area) => sum + (area?.area!), 0);
            validez = areaProyecto < sumAreas;
        }
        // Validación para tipo de áreas de construcción
        else if (tipoArea) {
            sumAreas = this.tramiteService.tiposAreas()
                .filter(area => area.idTipoArea === TipoAreaEnum.Areaconstruccion || area.idTipoArea === TipoAreaEnum.Areaampliar || area.idTipoArea === TipoAreaEnum.Areatechar || area.idTipoArea === TipoAreaEnum.Arearemodelar || area.idTipoArea === TipoAreaEnum.Areademoler || area.idTipoArea === TipoAreaEnum.Areapatiosyjardines)
                .reduce((sum, area) => sum + (area?.area!), 0);
            validez = areaProyecto < sumAreas;
        }
        return validez;
    }

    onCalcularTarifa(event: any) {
        if (event.key === '.' || event.key === ' ') {
            event.preventDefault();
        }
        console.log("onCalcularTarifa->",event)
        this.inputAreaTotal.next((event.target as HTMLInputElement).value);//Call debounce.
    }

    onChangeArea(event: any,areaObj: AreasInterfaces) {
        //Validaciones para evitar guardar areas invalidas
        if(!this.isAreaTerrenoValida())return;
        if(this.isValidarAreas(this.esConstruccion()))return;

        if(areaObj.area === null || areaObj.area === undefined || areaObj.area === 0)return;
        if (event.key === '.' || event.key === ' ') {
            event.preventDefault();
        }
        if (areaObj.area != null && areaObj.idProyecto != null && areaObj.area !== 0) {
            const areasRegisto: AreaChanged = {
                idTipoArea: areaObj.idTipoArea,
                idProyecto: this.tramiteService.idProyecto()!=null ? parseInt(this.tramiteService.idProyecto()!) : 0,
                area: areaObj.area,
                usuarioCreaModifica: this.loginServices.session()?.perfil.usuario!
            };
            this.formularioAService.actualizarAreas(areasRegisto).pipe(
                debounceTime(200), // Debounce for 200 milliseconds
                distinctUntilChanged(), // Only proceed if the query has changed
            ).subscribe({
                next: (result) => {
                    if (result) {
                        this._showLoader = false;
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
        }
        if (!this.isAreaTerrenoValida()) {
            Swal.fire({
                icon: 'error',
                title: '',
                text: 'La Área de proyecto debe ser mayor que las areas a desarrollar e impermeabilizar, por favor ingresar áreas correctas.'
            });
            this.tarifa = 0;
            return;
        }
        if (this.getAreaByTipo(TipoAreaEnum.Areaproyecto!) == null || this.getAreaByTipo(TipoAreaEnum.Areaproyecto!) == 0) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'La Área de proyecto no debe ser cero, por favor ingresar área correcta en el registro del proyecto.'
            });
            this.tarifa = 0;
            return;
        }

        this.onChangeCalcularTarifa();
    }
    onChangeAreasEstimadas(event: any,areaObj: AreasInterfaces) {
        if (event.key === '.' || event.key === ' ') {
            event.preventDefault();
        }

        if (areaObj.area != null && areaObj.idProyecto != null) {
            const areasRegisto: AreaChanged = {
                idTipoArea: areaObj.idTipoArea,
                idProyecto: this.tramiteService.idProyecto()!=null ? parseInt(this.tramiteService.idProyecto()!) : 0,
                area: areaObj.area,
                usuarioCreaModifica: this.loginServices.session()?.perfil.usuario!
            };
            this.formularioAService.actualizarAreas(areasRegisto).pipe(
                debounceTime(200), // Debounce for 200 milliseconds
                distinctUntilChanged(), // Only proceed if the query has changed
            ).subscribe({
                next: (result) => {
                    if (result) {
                        this._showLoader = false;
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
        }
        this.onChangeCalcularTarifa();
    }

    onChangeCalcularTarifa() {
        let areaTotal= this.getAreaByTipo(TipoAreaEnum.Areaproyecto!);

        if (areaTotal != null && areaTotal != 0) {
            this._showLoader = true;
            this.calcularTarifa().pipe(
                debounceTime(200), // Debounce for 200 milliseconds
                distinctUntilChanged(), // Only proceed if the query has changed
                catchError(error => {
                    let text = error.mensaje;
                    if (error.error && error.error.mensaje) {
                        text = error.error.mensaje; // Extract the custom message
                    } else if (error.message) {
                        text = error.message; // Fallback to the general error message
                    }
                    if (text.includes('api')) {
                        text = 'Ocurrió un error al procesar, intente mas tarde'
                    }

                    this.tramiteService.textTarifa='Calculo de tarifa no disponible en este momento.';
                    this._showLoader = false;
                    return throwError(error.statusText);
                })
            ).subscribe({
                next: (result) => {
                    if (result && result.body) {
                        let respuesta: TarifarioInterface[] | null = result.body
                        for (let i of respuesta!) {
                            if (i.total) {
                                this.tramiteService.textTarifa='';
                                this.tarifa = parseFloat(i.total.toFixed(2))!
                            } else {
                                this.tarifa = 0
                            }
                            console.log(`this.tarifa = ${this.tarifa}`)
                            console.log(`institucion =${this.loginServices.session()?.perfil.idInstitucion}`)
                        }
                        this._showLoader = false;
                    }
                },
                error: (error) => {
                    console.log(error)
                    this.tarifa = 0
                },
                complete: () => {
                }
            });
        }
    }

    calcularTarifa() {
        console.log(`calcularTarifa()`)
        this.tramiteCompleto = true
        let datos_calcular: TarifarioInterface[] = [
            {
                idEntorno: this.tramiteService.proyectoAsignado()[0].idEntorno!,
                idTramite: parseInt(this.idTramite!, 10),
                idTipoArea: this.tramiteService.tiposAreas().find(area => area.idTipoArea === TipoAreaEnum.Areaproyecto)?.idTipoArea!,
                area: this.getAreaByTipo(TipoAreaEnum.Areaproyecto!),
                idProyecto: this.tramiteService.idProyecto(),
                creadoPor: this.loginServices.session()?.perfil.usuario,
                idInstitucion: this.loginServices.session()?.perfil.idInstitucion,
                idSolicitud: this.tramiteService.proyectoAsignado()[0].idSolicitud!
            }
        ]
        return this.tramiteService.calcularTarifa(datos_calcular);
    }

    //TODO: Reescribir validaciones de este metodo, evaluar si es posible procesar en el backend. 28NOV2024
     completarTramite() {
        if(this.isLoading()) return;
        this.isLoading.set(true);
        this.obtenerSdetItemTramites();
    }

    validacionPrimerFlujoCompletarTramite() {
        this._showLoader = true;
        if (this.esConstruccion()) {
            if (this.selected && this.selected.idTramite!==undefined){
                this.obtenerAreasGeneralidadesTerreno("1", this.tramiteService.areasGeneralidadesTerrenoCompletadas());
                this.obtenerUnidadesHabitacionales(this.unidadesHabitacionales);
                this.completeFormProcess(this.selected)
            } else{
                this.obtenerAreasGeneralidadesTerreno("1", this.tramiteService.areasGeneralidadesTerrenoCompletadas());
                this.obtenerUnidadesHabitacionales(this.unidadesHabitacionales);
                const id = parseInt(this.tramiteService.idProyecto()!) ? parseInt(this.tramiteService.idProyecto()!) : 0;
                this.router.navigate(['/users/pagos/tramites', id])
                    .then(() => {
                        console.log(`tramites si requerir pago done` + JSON.stringify(this.route.snapshot.queryParams))
                    });

            }
        } else {
            if (this.selected && this.selected.idTramite!==undefined){
                this.obtenerAreasGeneralidadesTerreno("2", this.tramiteService.areasGeneralidadesTerrenoCompletadas());
                this.obtenerEtapasProyecto(this.listaEtapas);
                this.obtenerLotesAUrbanizar();
                this.completeFormProcess(this.selected)
            } else {
                this.obtenerAreasGeneralidadesTerreno("2", this.tramiteService.areasGeneralidadesTerrenoCompletadas());
                this.obtenerEtapasProyecto(this.listaEtapas);
                this.obtenerLotesAUrbanizar();
                const id = parseInt(this.tramiteService.idProyecto()!) ? parseInt(this.tramiteService.idProyecto()!) : 0;
                this.router.navigate(['/users/pagos/tramites', id])
                    .then(() => {
                        console.log(`tramites si requerir pago done` + JSON.stringify(this.route.snapshot.queryParams))
                    });
            }
        }
    }

    agregarEtapa() {
        if (this.cantidadEtapa != 0 && this.numeroMes != 0 && this.cantidadEtapa != null && this.numeroMes != null) {
            this.errorEtapas = false
            let etapa: EtapasProyectoInterfaces = {
                etapa: "",
                numeroEtapa: this.cantidadEtapa,
                cantidadMeses: this.numeroMes,
                usuarioCreaModifica: this.loginServices.session()?.perfil.usuario,
                idProyecto: parseInt(this.tramiteService.idProyecto()!)
            }
            this.listaEtapas.push(etapa)
            this.cantidadEtapa = 0
            this.numeroMes = 0
            this.dtEtapasProyecto.reset();
        } else {
            this.errorEtapas = true
        }
    }

    eliminarEtapas(index: number) {
        this.listaEtapas.splice(index, 1);
        this.dtEtapasProyecto.reset();
    }

    agregarUnidadHabitacional() {
        if (this.cantidadUnidades != 0 && this.cantidadUnidades != null && this.nivelSeleccionado != null) {
            this.errorUnidades = false
            let habitacionales: UnidadesHabitacionalesInterface = {
                cantidad: this.cantidadUnidades!,
                idNivel: parseInt(this.nivelSeleccionado?.id!),
                idProyecto: parseInt(this.tramiteService.idProyecto()!),
                usuarioCreaModifica: this.loginServices.session()?.perfil.usuario,
                descripcion: this.nivelSeleccionado?.descripcion!,
                idInstitucion: this.loginServices.session()?.perfil.idInstitucion!,
                idTramite: parseInt(this.selected.idTramite!)
            }
            const existe = this.unidadesHabitacionales.some(uh =>
                uh.cantidad === habitacionales.cantidad && uh.descripcion === habitacionales.descripcion
            );
            if (existe) {
                this.messageService.add({
                    severity: 'error',
                    detail: `Ya existe una unidad con cantidad ${habitacionales.cantidad} y ${habitacionales.descripcion}`,
                });
                return;
            }
            this.unidadesHabitacionales.push(habitacionales)
            this.cantidadUnidades = 0
            this.dtUnidadesHabitacionales.reset();
             // calcular tarifa para tramites que requieran
            this.obtenerUnidadesHabitacionales(this.unidadesHabitacionales);

        } else {
            this.errorUnidades = true
        }
    }

    eliminarUnidadHabitacional(index: number, item: UnidadesHabitacionalesInterface) {
        if (item!==null) {
            this.updateEstadoUniHabitacionales(item);
        }
        this.unidadesHabitacionales.splice(index, 1);
        this.dtUnidadesHabitacionales.reset();
    }

    /**
     Este metodo verifica si el id de un proyecto existe antes de finalizar el tramite
     y tambien hace un update cuando se agrega un nuevo proyecto de tipo flujo 2
     */
    validacionBotonCompletarTramite(): boolean {
        return this.tramiteService.idProyecto() == null;
    }

    /**
     Metodo que se utliza para obtener los valores ingresado de de las areas
     utilizando map que esta permitiendo asignar a las areas datos en el arreglo que se mantienen
     y que se asignan a tipo de area en la base de datos
     */
    obtenerAreasGeneralidadesTerreno(tipo: string, existen: boolean) {
        console.log("obtenerAreasGeneralidadesTerreno");
        if (!existen) {
            let areas:AreasInterfaces[];
            switch (tipo) {
                /**Proceso cuando es de tipo contruccion**/
                case "1":
                    //obtener las areas de tipo construccion mediante la variable signal y asignarle los valores adicionales para procesar
                    areas= this.tramiteService.tiposAreas().filter(areas=>(areas.idTipoArea==TipoAreaEnum.Adesarrollar || areas.idTipoArea==TipoAreaEnum.Aimpermeabilizar ||
                        areas.idTipoArea==TipoAreaEnum.Areaconstruccion || areas.idTipoArea==TipoAreaEnum.Areaampliar || areas.idTipoArea==TipoAreaEnum.Areatechar ||
                        areas.idTipoArea==TipoAreaEnum.Arearemodelar || areas.idTipoArea==TipoAreaEnum.Areademoler || areas.idTipoArea==TipoAreaEnum.Areapatiosyjardines))
                        .map(area => ({
                        ...area,
                        idProyecto: parseInt(this.tramiteService.idProyecto()!),
                        eliminado: null,
                        creadoPor: this.loginServices.session()?.perfil.usuario,
                        idSolicitudDetalle: 0
                    }))
                    this.registrarAreasGeneralidades(areas)
                    break;
                case "2":
                    /**Proceso cuando no es diferente de contruccion**/
                    //obtener las areas mediante la variable signal y asignarle los valores adicionales para procesar
                    areas= this.tramiteService.tiposAreas().filter(areas=>(areas.idTipoArea==TipoAreaEnum.Adesarrollar ||  areas.idTipoArea==TipoAreaEnum.Aimpermeabilizar ||
                        areas.idTipoArea==TipoAreaEnum.Arealotes || areas.idTipoArea==TipoAreaEnum.Areaverde || areas.idTipoArea==TipoAreaEnum.Areaequipamientosocial ||
                        areas.idTipoArea==TipoAreaEnum.Areaproteccion || areas.idTipoArea==TipoAreaEnum.Areacirculacion || areas.idTipoArea==TipoAreaEnum.Arealotetipo))
                        .map(area => ({
                        ...area,
                        idProyecto: parseInt(this.tramiteService.idProyecto()!),
                        eliminado: null,
                        creadoPor: this.loginServices.session()?.perfil.usuario,
                        idSolicitudDetalle: 0
                    }));
                    this.registrarAreasGeneralidades(areas)
                    break;
                default:
                    break;
            }
        }
    }

    registrarAreasGeneralidades(areas: AreasInterfaces[]) {
        this.tramiteService.procesarAreas(areas, parseInt(this.tramiteService.idProyecto()!)).pipe(
            catchError(error => {
                console.log(error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error al registrar',
                    detail: 'Fallo al registrar datos de áreas'
                });
                return of(null);
            })
        ).subscribe({
            next: result => {
                if (result && result.status === 200) {
                    console.log(`datos procesados para áreas`);
                }
            },
            error: error => console.log('error en el procesamiento de áreas:', error),
            complete: () => {
            }
        });
    }

    /**
     * Metodo que almacenar las etapas del formulario
     */
    obtenerEtapasProyecto(datosEtapas: EtapasProyectoInterfaces[]) {
        console.log("obtenerEtapasProyecto")
        if (this.listaEtapas.length > 0) {
            this.tramiteService.procesarEtapas(datosEtapas, parseInt(this.tramiteService.idProyecto()!)).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            console.log(`datos procesados etapas -> ${result}`);
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error al registrar',
                            detail: 'Fallo al registrar las etapas'
                        });
                    },
                    complete: () => {
                    }
                }
            )
        }
    }

    /**
     * Metodo que almacena los lotes urbanizacion
     */
    obtenerLotesAUrbanizar() {
        console.log("obtenerLotesAUrbanizarProyecto")
        if (this.cantidadLotes() != 0 && this.listaUrbanizacion != null) {
            let loteUrbanizar: LoteInterface [] = [{
                cantidadLotes: this.cantidadLotes(),
                idTipoLote: this.tipoLotes[0]?.id == undefined ? 6 : parseInt(this.tipoLotes[0]?.id!),
                usuarioCreaModifica: this.loginServices.session()?.perfil.usuario,
                idProyecto: parseInt(this.tramiteService.idProyecto()!),
                descripcion: this.tipoLotes[0]?.descripcion == undefined ? "" : this.tipoLotes[0]?.descripcion,
                idLocalizacion: isNaN(parseInt(this.localizacionSeleccionada()?.id!)) ? null : parseInt(this.localizacionSeleccionada()?.id!),
                idUrbanizacion: isNaN(parseInt(this.urbanizacionSeleccionada?.id!)) ? null : parseInt(this.urbanizacionSeleccionada?.id!),
                idDensidad: isNaN(parseInt(this.densidadSeleccionada()?.id!)) ? null : parseInt(this.densidadSeleccionada()?.id!)
            }]
            this.tramiteService.procesarLotes(loteUrbanizar, parseInt(this.tramiteService.idProyecto()!)).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            console.log(`datos procesados lotes -> ${result}`);
                            this.onChangeCalcularTarifa();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error al registrar',
                            detail: 'Fallo al registrar los lotes'
                        });
                    },
                    complete: () => {
                    }
                }
            )
        }
    }

    /**
     * Metodo que almacena las unidades habitacionales
     */
    obtenerUnidadesHabitacionales(unidadesHabitacionales: UnidadesHabitacionalesInterface[]) {
        console.log("obtenerDetallesConstruccion")
        if (this.unidadesHabitacionales.length > 0) {
            this.tramiteService.procesarUnidadesHabitacionales(unidadesHabitacionales, parseInt(this.tramiteService.idProyecto()!)).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            console.log(`datos procesados unidades habitacionales -> ${result}`);
                            this.onChangeCalcularTarifa();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error al registrar',
                            detail: 'Fallo al registrar las unidades habitacionales'
                        });
                    },
                    complete: () => {
                    }
                }
            )
        }
    }

    /**
     * <h4>Obtener informacion tramite</h4>
     * <p>Este metodo obtiene la informacion actualizada del proyecto vinculado al tramite</p>
     * <ul>
     *     <li>se detecto que las estaditisticas para los requisitos de tipo form, text en la respuesta no obtiene los datos actualizados cuando se completan
     *     de ultimo estos requisitos.</li>
     *     <li>este metodo al darle click al boton finalizar obtiene la información del proyecto o solictud vinculado al tramite,
     *     para obtener la informacion completa y actualizada cuando el usuario finalice el tramite</li>
     *     <li>el trámite para ser completado con exito debe cumplir con la informacion y todos los requisitos obligatorios.</li>
     *     <li>si el trámite ya cuenta con informacion y los requitos obligatorios completos se procesa y finaliza el trámite.</li>
     * </ul>
     * @since 13/01/2025
     */
    obtenerSdetItemTramites(){
         this.sdetTramiteService.obtenerSdetItem(this.tramiteService.idProyecto()!, this.idTramite!)
            .subscribe(
            {
                next: (resp) => {
                    if (resp) {
                        this.selected = resp.body!
                        this.procesarTramite();
                    }
                },
                error: (error) => {
                    console.log(error)
                    this.isLoading.set(false);
                },
                complete: () => {
                    this.isLoading.set(false);
                }
            }
        )
    }
    //TODO: Reescribir validaciones de este metodo, evaluar si es posible procesar en el backend. 28NOV2024
    procesarTramite() {
        this.tramiteCompleto = false;
        if (!this.tramiteService.areasGeneralidadesTerrenoCompletadas()) {
            if (!this.isAreaTerrenoValida()) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'La Área de proyecto debe ser mayor que las areas a desarrollar e impermeabilizar, favor ingresar áreas correctas.'
                });
                return;
            }
            if (!this.isAreasEstimadasValida(this.esConstruccion())) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Área de proyecto siempre debe ser mayor que la suma de las areas estimadas, favor revisar áreas ingresadas.'
                });
                return;
            }
            if (this.esConstruccion()) {
                if (this.getAreaByTipo(TipoAreaEnum.Areaconstruccion!) == 0 || this.getAreaByTipo(TipoAreaEnum.Areaconstruccion!) == null) {
                    this.messageService.add({
                        severity: 'error',
                        summary: '',
                        detail: 'Favor agregar el área de construcción, es requerida para el tramite del proyecto'
                    });
                    return;
                }
                if (this.unidadesHabitacionales == null || this.unidadesHabitacionales.length == 0) {
                    this.messageService.add({
                        severity: 'error',
                        summary: '',
                        detail: 'Favor agregar las unidades, es requerida para el tramite del proyecto'
                    });
                    return;
                }
            }
            if (!this.esConstruccion()) {
                if (!this.cantidadLotes()) {
                    this.messageService.add({
                        severity: 'error',
                        summary: '',
                        detail: 'Favor ingresar una cantidad valida de lotes.'
                    });
                    return;
                }
                if (!this.localizacionSeleccionada()) {
                    this.messageService.add({
                        severity: 'error',
                        summary: '',
                        detail: 'Favor seleccionar la localizacion.'
                    });
                    return;
                }
                if (!this.densidadSeleccionada()) {
                    this.messageService.add({
                        severity: 'error',
                        summary: '',
                        detail: 'Favor seleccionar la densidad.'
                    });
                    return;
                }
                if (this.listaEtapas == null || this.listaEtapas.length == 0) {
                    this.messageService.add({
                        severity: 'error',
                        summary: '',
                        detail: 'Favor agregar las etapas, es requerida para el tramite del proyecto.'
                    });
                    return;
                }
            }
            console.log("Cantidad lotes-->",this.cantidadLotes())
        }
        if (this.selected && this.selected.idTramite!==undefined) {
            if (!(this.selected.qtycumplidos === this.selected.qtyrequeridos)) {
                Swal.fire({
                    icon: "warning",
                    title: "Error",
                    text: "Favor debe cargar los archivos y documentos requeridos",
                    showDenyButton: true,
                    showConfirmButton: false,
                    denyButtonText: `Ok`
                }).then(r => console.log('Favor debe cargar los archivos y documentos requeridos'));
                return;
            }

            if (this.selected.idEstadoTramite !== EstadoTramiteEnum.NoRequierePago && (!this.tarifa)) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor calcular la tarifa del trámite'
                });
                return;
            }
        }
        console.log("Cantidad lotes-->",this.cantidadLotes())
        console.log("listaEtapas",this.listaEtapas)
        //Procesar los datos segun el tipo de flujo
        this.validacionPrimerFlujoCompletarTramite();
        this.tramiteCompleto = true
        console.log(`this.idProyecto= ${this.tramiteService.idProyecto()}, this.idTramite=${this.idTramite}`)
        console.log(`this.tarifa ->${this.tarifa}`)
    }
    private completeFormProcess(selected: TramiteItem) {
        this.tramiteService.completeFormProcess(selected)
            .pipe(
                tap(_ => console.log('SDet actualizado correctamente')),
                debounceTime(1000), // Debounce for 1000 milliseconds = 1 sec                            distinctUntilChanged(), // Only proceed if the query has changed
                switchMap(query => this.tramiteService.completeFormProcess(selected)),
                catchError(error => {
                    return throwError(() => error);
                })
            ).subscribe(
            resp => {
                if (resp.status == 200 || resp.status == 201) {
                    this._showLoader = false;
                    const id = selected.idProyecto ? selected.idProyecto : 0;
                    this.router.navigate(['/users/pagos/tramites', id])
                        .then(() => {
                            console.log(`tramites done` + JSON.stringify(this.route.snapshot.queryParams))
                        });
                }
            }
        )
    }
    /**
     * Metodo que actualiza las unidades habitacionales estado a remover
     */
    updateEstadoUniHabitacionales(unidadesHabitacionales: UnidadesHabitacionalesInterface) {
        console.log("updateestadoUniHabitacionales")
        if (unidadesHabitacionales !== null) {
            this.tramiteService.updateEstadoDetalleUnidades(unidadesHabitacionales).subscribe(
                {
                    next: (result) => {
                        if (result.status == 200) {
                            this.onChangeCalcularTarifa();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    },
                    complete: () => {
                    }
                }
            );
        }
    }
    tipoProyectoEffect = effect(() => {
        if (this.esConstruccion() != null) {
            if (this.esConstruccion()) {
                this.catalogoService.getCatalogo('nivel')
                    .subscribe(
                        resp => {
                            this.listaNivel = resp
                        }
                    )
            } else {
                this.catalogoService.getCatalogo('localizacion')
                    .subscribe(
                        resp => {
                            this.listaLocalizacion = resp
                        }
                    )
                this.catalogoService.getCatalogo('densidad')
                    .subscribe(
                        resp => {
                            this.listaDensidad = resp
                        }
                    )
            }
        }
    })
    localizacionDensidadEffect = effect(() => {
        if (this.localizacionSeleccionada() != null && this.densidadSeleccionada() != null) {
            this.catalogoService.getUrbanizacion('urbanizacion', this.localizacionSeleccionada()?.id!, this.densidadSeleccionada()?.id!)
                .subscribe(
                    resp => {
                        this.listaUrbanizacion = resp
                    }
                )
        }
    })

    /**Metodo que permite hacer el calculo de la tarifa de forma automatica siempre y cuando la tarifa no este vacia*/
    areaTotalEffect = effect(() => {
        if (this.tramiteService.areaTotalSignal() !== 0 && this.tramiteService.areaTotalSignal() !== null || (this.tramiteService.proyectoAsignado().length > 0 &&
            this.tramiteService.proyectoAsignado()[0]?.idEntorno !== undefined && this.tramiteService.tiposAreas().length > 0 )) {
            setTimeout(() => {
                this.onChangeCalcularTarifa();
            }, 200);
        }
    }, {allowSignalWrites: true});

    /**Metodo que filtra las areas generales para vizualizar en el formulario*/
    formAreasGenerales= computed(() => {//tipos de areas generales
        return this.tramiteService.tiposAreas().filter(areas=>(areas.idTipoArea==TipoAreaEnum.Areaproyecto || areas.idTipoArea==TipoAreaEnum.Adesarrollar ||
            areas.idTipoArea==TipoAreaEnum.Aimpermeabilizar));
    });

    /**Metodo que permite procesar los lotes el calculo de la tarifa de forma automatica cuando el tramite requiere calculo por lotes*/
    procesarLotesEffect = effect(() => {
        if (this.cantidadLotes() !== 0 && this.cantidadLotes() !== null &&
            this.densidadSeleccionada() !== null && this.localizacionSeleccionada() !== null) {
            this.obtenerLotesAUrbanizar();
        }
    }, {allowSignalWrites: true});

    validacionAreasGen(): boolean{
        const areas = this.formAreasGenerales();
        console.log("Areas ------>", areas);
        console.log("Areas map ------->", areas.map(ar => ar.area));
        console.log("Si hay areas invalidas --------->", areas.some(ar => ar.area === null || ar.area === undefined || ar.area === 0));
        return areas.length === 3 && areas.some(ar => ar.area === null || ar.area === undefined || ar.area === 0);
    }
    /**Metodo que filtra las areas dependiendo el tipo de proyectos para vizualizar en el formulario
     * Caso 1: Areas para proyectos de tipo diferente de construcción
     * Caso 2: Areas para proyectos de tipo construcción*/
    formAreas= computed(() => {
        if(!this.esConstruccion()){//tipos de areas para tipo de proyecto diferente de construccion
            return this.tramiteService.tiposAreas().filter(areas=>(areas.idTipoArea==TipoAreaEnum.Arealotes || areas.idTipoArea==TipoAreaEnum.Areaverde || areas.idTipoArea==TipoAreaEnum.Areaequipamientosocial ||
                areas.idTipoArea==TipoAreaEnum.Areaproteccion || areas.idTipoArea==TipoAreaEnum.Areacirculacion || areas.idTipoArea==TipoAreaEnum.Arealotetipo));
        }
        //tipos de areas para tipo de proyecto que son construccion
        return  this.tramiteService.tiposAreas().filter(areas=>(areas.idTipoArea==TipoAreaEnum.Areaconstruccion || areas.idTipoArea==TipoAreaEnum.Areaampliar ||  areas.idTipoArea==TipoAreaEnum.Areatechar ||
            areas.idTipoArea==TipoAreaEnum.Arearemodelar || areas.idTipoArea==TipoAreaEnum.Areademoler || areas.idTipoArea==TipoAreaEnum.Areapatiosyjardines ));
    });

    isNumericValidAreas(event: KeyboardEvent) {
        if (event.key) {
            isAlphaNumericValidEvent(event, 1);
        }
    }

    setLocalizacion(e: any) {
        this.localizacionSeleccionada.set(e)
    }

    setDensidad(e: any) {
        this.densidadSeleccionada.set(e)
    }

    setUrbanizacion(e: any) {
        this.urbanizacionSeleccionada = e
    }

    getAreaByTipo(tipo: TipoAreaEnum) {
        return this.tramiteService.tiposAreas().find(area => area.idTipoArea === tipo)?.area!;
    }

    goBack(): void {
        this.location.back();
    }
    onReceiveTramite(selected: TramiteItem): void {
        this.selected = selected;
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event): void {
        console.log('Page refresh detected');
        this.tramiteService.idProyecto.set(null)
        this.tramiteService.resetStatus()
    }

    prjDetConstruccion = computed(() => {
            if (this.tramiteService.proyectoAsignado()) {
                return this.tramiteService.proyectoAsignado()[0];
            } else {
                return null;
            }
        }
    );
    ngOnDestroy(): void {
        console.log(`formulario-a ngOnDestroy()->` + this.constructor.name)
        this.tramiteService.areasGeneralidadesTerrenoCompletadas.set(false);
        this.tramiteService.areaTotalSignal.set(0);
        this.tramiteService.tiposAreas.set([])
        this.tramiteService.proyectoAsignado.set([])
    }

    protected readonly top = top;
}
